<template>
  <div v-if="showLanguages" class="d-flex flex-wrap">
    <div v-for="(id, index) in adviserSpokenLanguages" :key="index" class="language-pill">
      <span>{{ getLanguageName(id) }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useIdentityStore } from '~conciergeUiCommons/store/identityStore'
const props = defineProps({
  adviserSpokenLanguages: {
    type: Array as () => string[],
    required: true
  }
})

const languagesMap = new Map([
  ['french', 'Français'],
  ['english', 'English'],
  ['spanish', 'Español'],
  ['german', 'Deutsch'],
  ['italian', 'Italiano'],
  ['arabic', 'العربية'],
  ['portuguese', 'Português'],
  ['japanese', '日本語'],
  ['cantonese', '廣東話'],
  ['romanian', 'Român'],
  ['russian', 'Русский'],
  ['greek', 'Ελληνικά'],
  ['vietnamese', 'Vietnamien'],
  ['creole', 'Créole'],
  ['serbo-croatian', 'Cрпскохрватски'],
  ['lao', 'ພາສາລາວ']
])

const identityStore = useIdentityStore()
const settings = identityStore.identity?.settings
const getLanguageName = (languageId: string) => {
  return languagesMap.get(languageId) || languageId
}

const showLanguages = computed((): boolean => {
  return (
    props.adviserSpokenLanguages?.length > 0 && (settings?.adviserSpokenLanguageEnabled ?? false)
  )
})
</script>
